import { useEffect, useState } from 'react';
import { useOrderContext } from '../context/OrderContext';
import { useUserContext } from '../context/UserContext';
import { orderActionTypes } from '../app/enums';
import OrderGrid from '../components/Order/OrderGrid';
import OrderDetails from './OrderDetails';
import { Orders as OrderService } from '../api/api';
import { Container, Grid, Typography } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    pageTitle: {
      color: theme.palette.primary.dark,
      fontWeight: 'bold',
    },
    gridSpacer: {
      minHeight: '12px',
    },
    container: {
      padding: 20,
    },
  }),
);

export const Orders = () => {
  const classes = useStyles(); 
  const { state, dispatch } = useOrderContext();
  const user = useUserContext();
  const [ loading, setLoading ] = useState(false);

  const loadOrderList = () => {
    setLoading(true);
    OrderService.getSelfOrders(user.state.self.locations[0].id)
      .then((orderList) => {
        dispatch({ type: orderActionTypes.LOAD_ORDER_LIST, orderList: orderList})
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log('Order details error', error)
      }) 
  }

  useEffect(() => {
    loadOrderList();
  }, [state.orderId])

  let orderDetails = state.orderId.length > 0
    ? <Grid item xs={4}>
        <Grid container className={classes.gridSpacer} />
        <Grid container className={classes.gridSpacer} />
        <OrderDetails />
      </Grid>
    : <Grid item></Grid>

  return (
    <Container
      component="main"
      className={classes.container}
    >
      <Grid container spacing = {0} style={{ width: '1200px' }}>
        <Grid item sm>
          <Typography className={classes.pageTitle} variant="h5">
            Orders
          </Typography>
          <Grid container className={classes.gridSpacer} />
          { loading 
            ? <Grid container 
                justifyContent="center"
                alignItems="center"
              >
                <CircularProgress color="primary" />
              </Grid>
            : <OrderGrid/>
          }      
        </Grid>  
        { orderDetails }
      </Grid>
    </Container>
  )
};

export default Orders;
